import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="mx-auto grid max-w-6xl gap-10 border-b border-slate-700/70 px-4 py-14 md:grid-cols-2 lg:grid-cols-[1.2fr_0.8fr_0.9fr_0.9fr]">
        <div>
          <div className="mb-4 inline-flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-sky-500 to-cyan-400 font-extrabold text-white">S</span>
            <h2 className="text-2xl font-bold">StartaWebb</h2>
          </div>
          <p className="max-w-md leading-relaxed text-slate-300">Kompletta hemsidor för små serviceföretag. Tydligt innehåll, enkel kontakt och ett skriftligt pris före beställning. Kommunikation på svenska eller arabiska.</p>
          <p className="mt-4 text-sm text-slate-400">Kristinehamn · uppdrag i hela Sverige.</p>
        </div>

        <div>
          <h3 className="mb-4 text-lg font-bold">Snabblänkar</h3>
          <ul className="space-y-3 text-slate-300">
            <li><a href="/#pris" className="hover:text-sky-300">Pris & innehåll</a></li>
            <li><Link to="/exempel/stadfirma" className="hover:text-sky-300">Exempel på hemsida</Link></li>
            <li><Link to="/samarbete" className="hover:text-sky-300">För designers & byråer</Link></li>
            <li><Link to="/ai-projekt" className="hover:text-sky-300">Hjälp med AI-projekt</Link></li>
            <li><Link to="/portfolio" className="hover:text-sky-300">Projekt</Link></li>
            <li><Link to="/faq" className="hover:text-sky-300">Vanliga frågor</Link></li>
            <li><Link to="/contact" className="hover:text-sky-300">Skicka förfrågan</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="mb-4 text-lg font-bold">Hemsidor för branscher</h3>
          <ul className="space-y-3 text-slate-300">
            <li><Link to="/hemsidor-for-smaforetag" className="font-semibold text-sky-300 hover:text-white">Alla branscher</Link></li>
            <li><Link to="/hemsida-stadfirma" className="hover:text-sky-300">Städfirma</Link></li>
            <li><Link to="/hemsida-flyttfirma" className="hover:text-sky-300">Flyttfirma</Link></li>
            <li><Link to="/hemsida-hantverkare" className="hover:text-sky-300">Hantverkare & bygg</Link></li>
            <li><Link to="/hemsida-frisor-salong" className="hover:text-sky-300">Frisör & salong</Link></li>
            <li><Link to="/hemsida-restaurang" className="hover:text-sky-300">Restaurang & café</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="mb-4 text-lg font-bold">Kontakt</h3>
          <div className="space-y-3 text-slate-300">
            <p><a href="mailto:info@startawebb.se" className="hover:text-sky-300">info@startawebb.se</a></p>
            <p><a href="tel:+46734877119" className="hover:text-sky-300">073-487-71-19</a></p>
            <p><a href="https://wa.me/46734877119" target="_blank" rel="noopener noreferrer" className="hover:text-sky-300">WhatsApp</a></p>
          </div>
          <Link to="/contact" className="mt-5 inline-flex rounded-xl bg-sky-600 px-5 py-3 font-bold text-white transition hover:bg-sky-500">Få ett kostnadsfritt förslag</Link>
        </div>
      </div>

      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 px-4 py-6 text-xs text-slate-400 md:flex-row">
        <p>© {new Date().getFullYear()} StartaWebb.</p>
        <nav className="flex flex-wrap justify-center gap-4">
          <Link to="/integritetspolicy" className="hover:text-white">Integritet</Link>
          <Link to="/användarvillkor" className="hover:text-white">Villkor</Link>
          <Link to="/cookies-policy" className="hover:text-white">Cookies</Link>
          <Link to="/ta-bort-personuppgifter" className="hover:text-white">Personuppgifter</Link>
        </nav>
      </div>
    </footer>
  );
}
